<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Monitor from "@/services/Monitor";
import ModalEditTenantTournament from "@/components/modals/social/modalEditTenantTournament";
import ModalAddTenantTournament from "@/components/modals/social/modalAddTenantTournament";
import Swal from "sweetalert2";

export default {
  components: {
    Layout,
    PageHeader,
    ModalEditTenantTournament,
    ModalAddTenantTournament,
  },
  page: {
    title: "Tenant Tournament",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      error: null,


      tableData: [],
      tableDataTournament: [],
      title: "Tenant Tournament",
      items: [
        {
          text: "Sport Data",
        },
        {
          text: "Tenant Tournament",
          active: true,
        },
      ],

      filterInput: {},
      isBusy: false,
      totalRows: 0,
      totalRowsTournament: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "valid_from",
      sortDesc: true,
      dealData: [],
      tenantSetupData: [],
      fields: [
        {
          key: "tenant_team_id",
          label: "Tenant Team Id",
          visible: false,

        },
        {
          key: "tenant",
          label: "Tenant",
          visible: true,
        },
        {
          key: "tournament_id",
          label: "Tournament Id",
          visible: true,
        },
        {
          key: "tournament_season",
          label: "Tournament Season",
          visible: true,
        },
        {
          key: "competition_id",
          label: "Competition Id",
          visible: true,
        },
        {
          key: "competition_name",
          label: "Competition Name",
          visible: true,
        },
        {
          key: "competition_type",
          label: "Competition Type",
          visible: true,
        },
        {
          key: "active_season",
          label: "Active Season",
          visible: true,
        },
        {
          key: "primary",
          label: "Primary",
          visible: true,
        },
        {
          key: "order",
          label: "Order",
          visible: true,
        },
        {
          key: "Action",
          label: "Action",
        }
      ],
      statusOptions: [],
      isBusyAll: false,
      totalRowsAll: 0,
      currentPageAll: 1,
      perPageAll: 10,
      pageOptionsAll: [10, 25, 50, 100],
      filterAll: null,
      filterOnAll: [],
      filterData: false,
    };
  },

  async created() {
    await this.getAllTenantsTournament();
  },
  methods: {


    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.totalRowsTournament = filteredItems.length;
      this.currentPage = 1;
    },

    async getAllTenantsTournament() {

      try {
        this.filterData = true;
        this.isBusy = true;
        var filters = '';
        const response = await Monitor.getAllTenantsTournament(filters);
        this.tableData = response.data.data
        this.totalRows = this.tableData.length
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.error = error.response.data.error ? error.response.data.error : "";
        this.tableData = []
        this.totalRows = 0
      }
    },

    callModalEditTeamDeal(data) {
      this.$bvModal.show("edit_tenant_tournament");
      this.tenantSetupData = data
    },

    callModalAddTenantSetup(data) {
      this.$bvModal.show("add_tenant_tournament");
      this.tenantSetupData = data
    },
    deleteTenantTournament(tenant_team_id, tournament_id) {
      console.log("Attempting to delete Tenant Tournament with:", {
        tenant_team_id,
        tournament_id
      });
      const data = { tenant_team_id: tenant_team_id, tournament_id: tournament_id };
      Swal.fire({
        title: "Are you sure?",
        text: "Remove From Tenant Tournament!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          console.log("Attempting to delete data Tournament with:", {
            data
          });
          Monitor.deleteTenantTournament(data)
              .then((response) => {
                const res = response.data.delete ? response.data.delete : false;
                const error = response.data.error ? response.data.error : '';
                if (res && !error) {
                  this.getAllTenantsTournament();
                  this.successmsg("Tenant Tournament Successfully Removed");
                } else {
                  this.failedmsg("Tenant Tournament Removal Failed");
                }
              })
              .catch(error => {
                this.failedmsg('Fail!', error);
              });
        }
      });
    }
  },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :fields="fields"/>
    <div class="row">
      <div class="col-12">

        <div class="card" v-show="filterData">
          <div class="card-body">
            <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light"
               @click="callModalAddTenantSetup">
              <i class="mdi mdi-plus me-2"></i>Add New Tenant Tournament
            </a>

            <div class="row mt-4">
              <div class="col d-inline-flex align-items-center">
                <h4 class="card-title m-0">Total Tenant Tournaments: {{ totalRows }}</h4>
              </div>
            </div>

            <div class="row mt-4" v-show="filterData">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="deals-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0 font-size-12" v-show="filterData">
              <b-table
                  :items="tableData"
                  :busy="isBusy"
                  :fields="fields"
                  :visible="fields.visible"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  show-empty
                  empty-text="No Data Found"
              >
                <template v-slot:cell(action)="data">
                  <ul class="list-inline mb-0 flo">
                    <li class="list-inline-item">
                      <a href="javascript:void(0);" class="px-2 text-primary" title="Edit Tenant Tournament"
                         @click="callModalEditTeamDeal(data.item)">
                        <i class="uil uil-pen font-size-18"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0);" class="px-2 text-danger" title="Remove Tenant Tournament"
                         @click="deleteTenantTournament(data.item.tenant_team_id, data.item.tournament_id)">
                        <i class="uil uil-trash-alt font-size-18"></i>
                      </a>
                    </li>
                  </ul>
                </template>

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>

              </b-table>
            </div>
            <!--Table end -->

            <div class="row" v-show="filterData">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- MODALS -->
    <ModalEditTenantTournament :tenantSetupData="tenantSetupData" @onRefresh="getAllTenantsTournament()"></ModalEditTenantTournament>
    <ModalAddTenantTournament :tenantSetupData="tenantSetupData" @onRefresh="getAllTenantsTournament();"></ModalAddTenantTournament>
    <!-- /MODALS -->

  </Layout>
</template>
